import { useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelectedVessel, vesselScopedRoute } from "../logbook/useSelectedVessel";

export default function VesselSelector() {
  const { t } = useTranslation();
  const { vessel, vessels, query, select } = useSelectedVessel();
  const location = useLocation();
  const [params, setParams] = useSearchParams();
  if (query.isPending) return <span className="text-sm" aria-label={t("logbook.vessel")}>…</span>;
  if (query.isError) return <button className="text-sm text-red-700" onClick={() => void query.refetch()}>{t("logbook.retry")}</button>;
  if (!vessels.length) return null;
  if (vessels.length === 1 && vessel) return <span className="max-w-36 truncate text-sm font-semibold" title={vessel.name}>{vessel.name}</span>;
  return <select aria-label={t("logbook.vessel")} className="touch-target max-w-36 rounded border border-gray-300 bg-white px-2 py-2 text-sm" value={vessel?.id ?? ""} onChange={event => {
    const id = event.target.value;
    select(id);
    const scoped = vesselScopedRoute(location.pathname, params);
    if (scoped) {
      const next = new URLSearchParams(params);
      next.set("vesselId", id);
      next.delete("engineId");
      next.delete("inspect");
      setParams(next);
    }
  }}>
    {!vessel && <option value="" disabled>{t("logbook.noVessel")}</option>}
    {vessels.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
  </select>;
}
